import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  modulooi4g1kq3dmtt as modulo,
  dividelr0uqtdj497z as divide,
  convertToInty04h231mmjoh as convertToInt,
  shiftRight2gqph14wydb8s as shiftRight,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
  safeMultiplyomi65rg5l1en as safeMultiply_0,
} from './internal/mathJs.mjs';
import {
  TimeBasedDateTimeUnitSerializer_getInstancewuqoobna26f2 as TimeBasedDateTimeUnitSerializer_getInstance,
  DateBasedDateTimeUnitSerializer_getInstance2rikesu6oglqz as DateBasedDateTimeUnitSerializer_getInstance,
  DayBasedDateTimeUnitSerializer_getInstance23o8q93ovx0p5 as DayBasedDateTimeUnitSerializer_getInstance,
  MonthBasedDateTimeUnitSerializer_getInstancecpechj7jc0xd as MonthBasedDateTimeUnitSerializer_getInstance,
  DateTimeUnitSerializer_getInstance3b5n2mvis6ri5 as DateTimeUnitSerializer_getInstance,
} from './serializers/DateTimeUnitSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var TimeBasedClass;
function TimeBased() {
  if (TimeBasedClass === VOID) {
    class $ extends DateTimeUnit() {
      constructor(nanoseconds) {
        super();
        this.f1n_1 = nanoseconds;
        // Inline function 'kotlin.require' call
        if (!(this.f1n_1 > 0n)) {
          var message = 'Unit duration must be positive, but was ' + this.f1n_1.toString() + ' ns.';
          throw IllegalArgumentException().a1(toString(message));
        }
        if (modulo(this.f1n_1, 3600000000000n) === 0n) {
          this.g1n_1 = 'HOUR';
          this.h1n_1 = divide(this.f1n_1, 3600000000000n);
        } else {
          if (modulo(this.f1n_1, 60000000000n) === 0n) {
            this.g1n_1 = 'MINUTE';
            this.h1n_1 = divide(this.f1n_1, 60000000000n);
          } else {
            var tmp0 = this.f1n_1;
            // Inline function 'kotlin.Long.rem' call
            var other = 1000000000;
            if (modulo(tmp0, fromInt(other)) === 0n) {
              this.g1n_1 = 'SECOND';
              var tmp = this;
              var tmp0_0 = this.f1n_1;
              // Inline function 'kotlin.Long.div' call
              var other_0 = 1000000000;
              tmp.h1n_1 = divide(tmp0_0, fromInt(other_0));
            } else {
              // Inline function 'kotlin.Long.rem' call
              var this_0 = this.f1n_1;
              if (modulo(this_0, fromInt(1000000)) === 0n) {
                this.g1n_1 = 'MILLISECOND';
                var tmp_0 = this;
                // Inline function 'kotlin.Long.div' call
                var this_1 = this.f1n_1;
                tmp_0.h1n_1 = divide(this_1, fromInt(1000000));
              } else {
                // Inline function 'kotlin.Long.rem' call
                var this_2 = this.f1n_1;
                if (modulo(this_2, fromInt(1000)) === 0n) {
                  this.g1n_1 = 'MICROSECOND';
                  var tmp_1 = this;
                  // Inline function 'kotlin.Long.div' call
                  var this_3 = this.f1n_1;
                  tmp_1.h1n_1 = divide(this_3, fromInt(1000));
                } else {
                  this.g1n_1 = 'NANOSECOND';
                  this.h1n_1 = this.f1n_1;
                }
              }
            }
          }
        }
      }
      i1n(scalar) {
        return new (TimeBased())(safeMultiply(this.f1n_1, fromInt(scalar)));
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof TimeBased()) {
            tmp_0 = this.f1n_1 === other.f1n_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return convertToInt(this.f1n_1) ^ convertToInt(shiftRight(this.f1n_1, 32));
      }
      toString() {
        return this.j1n(this.h1n_1, this.g1n_1);
      }
    }
    initMetadataForClass($, 'TimeBased', VOID, VOID, VOID, VOID, VOID, {0: TimeBasedDateTimeUnitSerializer_getInstance});
    TimeBasedClass = $;
  }
  return TimeBasedClass;
}
var DateBasedClass;
function DateBased() {
  if (DateBasedClass === VOID) {
    class $ extends DateTimeUnit() {}
    initMetadataForClass($, 'DateBased', VOID, VOID, VOID, VOID, VOID, {0: DateBasedDateTimeUnitSerializer_getInstance});
    DateBasedClass = $;
  }
  return DateBasedClass;
}
var DayBasedClass;
function DayBased() {
  if (DayBasedClass === VOID) {
    class $ extends DateBased() {
      constructor(days) {
        super();
        this.l1n_1 = days;
        // Inline function 'kotlin.require' call
        if (!(this.l1n_1 > 0)) {
          var message = 'Unit duration must be positive, but was ' + this.l1n_1 + ' days.';
          throw IllegalArgumentException().a1(toString(message));
        }
      }
      i1n(scalar) {
        return new (DayBased())(safeMultiply_0(this.l1n_1, scalar));
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof DayBased()) {
            tmp_0 = this.l1n_1 === other.l1n_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.l1n_1 ^ 65536;
      }
      toString() {
        return (this.l1n_1 % 7 | 0) === 0 ? this.k1n(this.l1n_1 / 7 | 0, 'WEEK') : this.k1n(this.l1n_1, 'DAY');
      }
    }
    initMetadataForClass($, 'DayBased', VOID, VOID, VOID, VOID, VOID, {0: DayBasedDateTimeUnitSerializer_getInstance});
    DayBasedClass = $;
  }
  return DayBasedClass;
}
var MonthBasedClass;
function MonthBased() {
  if (MonthBasedClass === VOID) {
    class $ extends DateBased() {
      constructor(months) {
        super();
        this.m1n_1 = months;
        // Inline function 'kotlin.require' call
        if (!(this.m1n_1 > 0)) {
          var message = 'Unit duration must be positive, but was ' + this.m1n_1 + ' months.';
          throw IllegalArgumentException().a1(toString(message));
        }
      }
      i1n(scalar) {
        return new (MonthBased())(safeMultiply_0(this.m1n_1, scalar));
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof MonthBased()) {
            tmp_0 = this.m1n_1 === other.m1n_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.m1n_1 ^ 131072;
      }
      toString() {
        return (this.m1n_1 % 1200 | 0) === 0 ? this.k1n(this.m1n_1 / 1200 | 0, 'CENTURY') : (this.m1n_1 % 12 | 0) === 0 ? this.k1n(this.m1n_1 / 12 | 0, 'YEAR') : (this.m1n_1 % 3 | 0) === 0 ? this.k1n(this.m1n_1 / 3 | 0, 'QUARTER') : this.k1n(this.m1n_1, 'MONTH');
      }
    }
    initMetadataForClass($, 'MonthBased', VOID, VOID, VOID, VOID, VOID, {0: MonthBasedDateTimeUnitSerializer_getInstance});
    MonthBasedClass = $;
  }
  return MonthBasedClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        this.n1n_1 = new (TimeBased())(1n);
        this.o1n_1 = this.n1n_1.i1n(1000);
        this.p1n_1 = this.o1n_1.i1n(1000);
        this.q1n_1 = this.p1n_1.i1n(1000);
        this.r1n_1 = this.q1n_1.i1n(60);
        this.s1n_1 = this.r1n_1.i1n(60);
        this.t1n_1 = new (DayBased())(1);
        this.u1n_1 = this.t1n_1.i1n(7);
        this.v1n_1 = new (MonthBased())(1);
        this.w1n_1 = this.v1n_1.i1n(3);
        this.x1n_1 = this.v1n_1.i1n(12);
        this.y1n_1 = this.x1n_1.i1n(100);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var DateTimeUnitClass;
function DateTimeUnit() {
  if (DateTimeUnitClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance_3();
      }
      k1n(value, unit) {
        return value === 1 ? unit : '' + value + '-' + unit;
      }
      j1n(value, unit) {
        return value === 1n ? unit : value.toString() + '-' + unit;
      }
    }
    initMetadataForClass($, 'DateTimeUnit', VOID, VOID, VOID, VOID, VOID, {0: DateTimeUnitSerializer_getInstance});
    DateTimeUnitClass = $;
  }
  return DateTimeUnitClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
//endregion
//region block: exports
export {
  Companion_getInstance_3 as Companion_getInstance1hjnoi8x2xjhl,
  DateBased as DateBasedu1hioe8kvjhw,
  DayBased as DayBased28hvf1xjg5r93,
  MonthBased as MonthBased16lxw4e6nhntg,
  TimeBased as TimeBasedn2y4mla0fo0k,
  DateTimeUnit as DateTimeUnit3ugctnw90699o,
};
//endregion

//# sourceMappingURL=DateTimeUnit.mjs.map
